/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
export type CategoriesItem = {
  id: string | number;
  categories: string[];
};

/**
 * Returns the flex order of the legend and chart in the flex container.
 * @param legendPos The legend position.
 * @returns
 */
export function getFlexOrder(legendPos: 'start' | 'top' | 'bottom' | 'end') {
  const isLegendFirst = legendPos === 'start' || legendPos === 'top';
  return {
    chartOrder: isLegendFirst ? 2 : 1,
    legendOrder: isLegendFirst ? 1 : 2
  };
}

/**
 * Returns the legend flex align and justify prop.
 */
export function getLegendFlexProps(legendPos: 'start' | 'end' | 'top' | 'bottom') {
  let justifyContent: 'center' | 'start' | 'end';
  let alignItem: 'center' | 'start' | 'end';
  if (legendPos === 'top') {
    justifyContent = 'center';
    alignItem = 'end';
  } else if (legendPos === 'bottom') {
    justifyContent = 'center';
    alignItem = 'start';
  } else if (legendPos === 'start') {
    justifyContent = 'end';
    alignItem = 'center';
  } else {
    justifyContent = 'start';
    alignItem = 'center';
  }

  return { justifyContent, alignItem };
}
